import { createAsyncThunk } from '@reduxjs/toolkit'
import { apiCall, getData } from '../../../utility/apiHelpers'
import { ApiUrls } from '../../../utility/ApiUrls'

export const GetAuditReport = createAsyncThunk("appCommonReducers/GetAuditReport", async (wdata) => {
    const woidDate = wdata.object
    const method = 'get'
    const endpoint = `${woidDate.ccode}/${woidDate.tcode}/${ApiUrls.GetAuditReport}?woId=${woidDate.woId}`
    const data = wdata.woidDate
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const ProcessAuditReportStage = createAsyncThunk("appCommonReducers/ProcessAuditReportStage", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ProcessAuditReportStage}`
    const data = getData(wdata.obj, wdata.ccode, wdata.tcode)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetMPDetailsFilter = createAsyncThunk("appCommonReducers/GetMPDetailsFilter", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.GetMPDetailsFilter
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workordersDto = resultData.mpDetailsList ? resultData.mpDetailsList : []
        const recCount = resultData.totalCount
        const gridSize = resultData.pageSize
        return {
            data: workordersDto,
            recCount,
            gridSize,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const SearchMPList = createAsyncThunk("appCommonReducers/SearchMPList", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.SearchMPList}?searchValue=${wdata.value}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetDownloadData = createAsyncThunk("appCommonReducers/GetDownloadData", async (code) => {
    const woId = code?.woData?.id
    const method = 'get'
    const endpoint = `${code.ccode}/${code.tcode}/${ApiUrls.GetDownloadData}?woId=${woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetDownloadCertData = createAsyncThunk("appCommonReducers/GetDownloadCertData", async (code) => {
    const woId = code?.woId
    const fileId = code?.fileId
    const method = 'get'
    const endpoint = `${code.ccode}/${code.tcode}/${ApiUrls.GetDownloadCertData}?woId=${woId}&fileId=${fileId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetSubmissionReport = createAsyncThunk("appCommonReducers/GetSubmissionReport", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetSubmissionReport}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetBookSalesAnalysis = createAsyncThunk("appCommonReducers/GetBookSalesAnalysis", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetBookSalesAnalysis}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetSalesAnalysisMiscFee = createAsyncThunk("appCommonReducers/GetSalesAnalysisMiscFee", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetSalesAnalysisMiscFee}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetCurrentWorkOrderStateCounts = createAsyncThunk("appCommonReducers/GetCurrentWorkOrderStateCounts", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetCurrentWorkOrderStateCounts}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetWorkOrderSummaryStatistics = createAsyncThunk("appCommonReducers/GetWorkOrderSummaryStatistics", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetWorkOrderSummaryStatistics}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetMiscChargesStatistics = createAsyncThunk("appCommonReducers/GetMiscChargesStatistics", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetMiscChargesStatistics}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetSqcSignerStatistics = createAsyncThunk("appCommonReducers/GetSqcSignerStatistics", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetSqcSignerStatistics}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetSeafarerStatistics = createAsyncThunk("appCommonReducers/GetSeafarerStatistics", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetSeafarerStatistics}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetDocumentChargesStatistics = createAsyncThunk("appCommonReducers/GetDocumentChargesStatistics", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetDocumentChargesStatistics}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetWorkOrderHistory = createAsyncThunk("appCommonReducers/GetWorkOrderHistory", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetWorkOrderHistory}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetApplicationHistory = createAsyncThunk("appCommonReducers/GetWorkOrderHistory", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetApplicationHistory}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetLicenseRenewals = createAsyncThunk("appCommonReducers/GetLicenseRenewals", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetLicenseRenewals}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetClosedWorkOrders = createAsyncThunk("appCommonReducers/GetClosedWorkOrders", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetClosedWorkOrders}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateSubmissionExpedite = createAsyncThunk("appCommonReducers/UpdateSubmissionExpedite", async (wdata) => {
    const method = 'post'
    const endpoint = ApiUrls.UpdateSubmissionExpedite
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return { data: resultData, spinner: true, tokenExp: false }
    } else {
        return { data: [], spinner: true, tokenExp: false }
    }
})
